import { kind as disable } from '../../actions/goals/Disable';
import { kind as rebuild } from '../../actions/goals/Rebuild';
import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { reject as rejectGoals, resolve as resolveGoals } from '../../GoalResolvers';
import { State } from '../../State';
import { destroy } from './destroy';
import { suspend } from './suspend';
import { wipe } from './wipe';

export function logOut(state: State): State {
  let goalResolvers = state.goalResolvers;
  const reason = 'Logging Out';
  goalResolvers = rejectGoals(goalResolvers, rebuild, reason);
  goalResolvers = rejectGoals(goalResolvers, start, reason);
  goalResolvers = rejectGoals(goalResolvers, restart, reason);

  if (state.replication) {
    return suspend({ ...state, goalResolvers });
  }

  goalResolvers = resolveGoals(goalResolvers, disable);

  if (state.database) {
    return destroy({ ...state, disabled: true, goalResolvers });
  }

  return {
    ...state,
    disabled: true,
    goalResolvers,
    nextTask: wipe(),
  };
}
